const AboutMission = ({ data }) => (
  <section className="py-28 bg-white">
    <div className="max-w-5xl mx-auto px-6 text-center">
      <h2 className="text-4xl font-bold text-[#0a363c] mb-6">{data.title}</h2>
      <p className="text-xl text-[#0a363c]/80 leading-relaxed max-w-3xl mx-auto">
        {data.description}
      </p>
    </div>
  </section>
);

export default AboutMission;
